export const getLoading = (state) => state.bidding.loading;
export const getAccepted = (state) => state.bidding.accepted;
export const getError = (state) => state.bidding.error;
export const getMessage = (state) => state.bidding.message;

